module.exports = __webpack_public_path__ + "static/media/ic_twitter.2a5aa749.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_twitter.svg
// module id = 155
// module chunks = 0